<template>
  <div v-if="contracts.length > 1" class="tcs">
    <label class="tcs__label" for="tcs-select">Contrato</label>
    <select id="tcs-select" class="tcs__select" :value="modelValue" @change="$emit('update:modelValue', $event.target.value)">
      <option v-for="c in contracts" :key="c.id" :value="c.id">
        {{ c.plotName }} · {{ statusLabel(c.status) }}
      </option>
    </select>
  </div>
</template>

<script setup>
defineProps({
  contracts: { type: Array, default: () => [] },
  modelValue: { type: String, default: null },
})
defineEmits(['update:modelValue'])

const STATUS = { ACTIVE: 'Vigente', PENDING: 'Por iniciar', ENDED: 'Terminado' }
const statusLabel = (s) => STATUS[s] || s
</script>

<style scoped>
.tcs { display: flex; align-items: center; gap: 8px; }
.tcs__label { font: 500 11px Inter, sans-serif; color: #94a3b8; text-transform: uppercase; letter-spacing: 0.4px; }
.tcs__select {
  height: 32px; padding: 0 10px; border: 1px solid #e2e8f0; border-radius: 6px; background: #fff;
  font: 500 13px Inter, sans-serif; color: #1e3a5f; max-width: 100%;
}
</style>